import { z } from "zod/v4";

export const GetScriptStatusQueryParamSchema = z.object({
  themeId: z.string().optional(),
  fullUrl: z.string().optional(),
});
export type GetScriptStatusQueryParamType = z.infer<
  typeof GetScriptStatusQueryParamSchema
>;

export const GetScriptStatusResponseBodySchema = z.discriminatedUnion("type", [
  z.object({
    type: z.literal("error"),
    exists: z.literal(false),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
  z.object({
    type: z.literal("inlineFound"),
    exists: z.literal(true),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
  z.object({
    type: z.literal("importMapError"),
    exists: z.literal(true),
    hasTemplateScript: z.boolean().default(false).optional(),
    scriptLine: z.number(),
    importMapLine: z.number(),
  }),
  z.object({
    type: z.literal("inlineAsyncFound"),
    exists: z.literal(true),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
  z.object({
    type: z.literal("incorrectScriptFound"),
    expected: z.string(),
    exists: z.literal(true),
    found: z.string(),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
  z.object({
    type: z.literal("appEmbedFound"),
    exists: z.literal(true),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
  z.object({
    type: z.literal("multipleScriptsWithAppEmbedFound"),
    exists: z.literal(true),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
  z.object({
    type: z.literal("multipleScriptsFound"),
    exists: z.literal(true),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
  z.object({
    type: z.literal("headlessMissing"),
    exists: z.literal(false),
  }),
  z.object({
    type: z.literal("headlessFound"),
    exists: z.literal(true),
  }),
  z.object({
    type: z.literal("headlessDeprecatedFound"),
    minimumSupported: z.string(),
    expected: z.string(),
    found: z.string(),
    exists: z.literal(true),
  }),
  z.object({
    type: z.literal("headlessOutdatedFound"),
    found: z.string(),
    expected: z.string(),
    exists: z.literal(true),
  }),
  z.object({
    type: z.literal("missing"),
    exists: z.literal(false),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
  z.object({
    type: z.literal("isCjs"),
    exists: z.literal(true),
    hasTemplateScript: z.boolean().default(false).optional(),
  }),
]);

export type GetScriptStatusResponseBodyType = z.infer<
  typeof GetScriptStatusResponseBodySchema
>;
